import { transformUserDataFromStorage } from "../utils/api";
import {
  applyLocaleToDocument,
  resolveLocale,
  writeStoredLocale,
} from "../utils/locale";

const USER_STORAGE_KEY = "userData";
const ACCESS_TOKEN_STORAGE_KEY = "accessToken";

export const userSessionStorage = {
  getItem: (key) => {
    try {
      return typeof localStorage === "undefined" ? null : localStorage.getItem(key);
    } catch (err) {
      console.warn("[userSessionPersistence] localStorage.getItem échoue", err?.message);
      return null;
    }
  },
  setItem: (key, value) => {
    try {
      if (typeof localStorage !== "undefined") {
        localStorage.setItem(key, value);
      }
    } catch (err) {
      console.warn("[userSessionPersistence] localStorage.setItem échoue", err?.message);
    }
  },
  removeItem: (key) => {
    try {
      if (typeof localStorage !== "undefined") {
        localStorage.removeItem(key);
      }
    } catch (err) {
      console.warn("[userSessionPersistence] localStorage.removeItem échoue", err?.message);
    }
  },
};

export const readCachedUserSnapshot = () => {
  try {
    const raw = userSessionStorage.getItem(USER_STORAGE_KEY);
    return transformUserDataFromStorage(raw ? JSON.parse(raw) : null);
  } catch {
    return null;
  }
};

export const persistHydratedUserData = ({
  userData,
  preferredLocale,
  fallbackLocale,
} = {}) => {
  if (!userData) return null;
  const resolvedLocale = resolveLocale(
    preferredLocale || userData?.preferredLocale || fallbackLocale
  );
  const nextUser = {
    ...userData,
    preferredLocale: resolvedLocale,
  };
  userSessionStorage.setItem(USER_STORAGE_KEY, JSON.stringify(nextUser));
  writeStoredLocale(resolvedLocale);
  applyLocaleToDocument(resolvedLocale);
  return {
    userData: nextUser,
    preferredLocale: resolvedLocale,
  };
};

export const clearCachedUserSession = () => {
  userSessionStorage.removeItem(ACCESS_TOKEN_STORAGE_KEY);
  userSessionStorage.removeItem(USER_STORAGE_KEY);
};
